// @ts-nocheck
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductAddToListLink from "@insite/content-library/Components/ProductAddToListLink";
import { DataTableCell, Typography } from "@insite/mobius/index";
import ProductAddToCartButton from "@store/Overrides/Components/ProductAddToCartButton";
import { ProductContextsBySku } from "@store/Framework/Common/Hooks/useProductContextsBySku";
import React from "react";
import styled, { css } from "styled-components";

// merging the interface for to GetProductionCollectionApi to fix the incomplete typing.

const StyledProductAddToListLink = styled(ProductAddToListLink)`
    padding: 0.625rem 1.25rem;
    min-height: 40px;
`;
interface Props {
    sku: string;
    productContextsBySku: ProductContextsBySku;
}
const CenteredDataTableCell = styled(DataTableCell)`
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 1.5rem;
`;
interface Props {
    sku: string;
    productContextsBySku: ProductContextsBySku;
}
const AddToCartAndWishList: React.FC<Props> = ({ sku, productContextsBySku }) => {
    const [productValue, setProductValue] = React.useState<ProductContextModel>();
    const fixedSku = sku.replace(/\D/g, "");
    if (!productValue && productContextsBySku?.[fixedSku]) {
        const { product, productInfo } = productContextsBySku[fixedSku];
        if (product && productInfo) {
            setProductValue({ product, productInfo });
        }
    }

    return (
        <>
            {productValue?.product ? (
                <ProductContext.Provider value={productValue}>
                    <CenteredDataTableCell>
                        <ProductAddToCartButton />
                        <StyledProductAddToListLink />
                    </CenteredDataTableCell>
                </ProductContext.Provider>
            ) : (
                <CenteredDataTableCell>
                    <Typography>{translate("Contact Bunzl")}</Typography>
                </CenteredDataTableCell>
            )}
        </>
    );
};

export default AddToCartAndWishList;
